import React, { useState } from "react";
import axios from "axios";
import Apply1 from "../../assets/Career/Apply1.svg";
import Apply2 from "../../assets/Career/Apply2.svg";
import Apply3 from "../../assets/Career/Apply3.svg";
import toast from "react-hot-toast";

const NewsLetter = () => {
  const [email, setEmail] = useState("");
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter an email address.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE}subscribe`, {
        email,
      });
      toast.success(response.data.message || "Thanks for Subscribing!");
      setEmail("");
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.detail || "Subscription failed.");
      } else {
        toast.error("An error occurred. Please try again.");
      }
    }
  };

  return (
    <div
      className="w-full max-w-[1440px] md:px-[120px] px-[10px] mb-[30px]"
      id="newsletter"
    >
      <div className="w-full max-w-[1200px] flex lg:flex-row flex-col justify-between items-center bg-[#E8EBF0] px-[16px] md:px-[24px] py-[8px] rounded-lg md:gap-0 gap-[4px]">
        <div className="flex gap-[18px] items-center w-full">
          <div className="flex">
            <span className="w-[58px] h-[51px] flex-shrink-0 rounded-[58px] flex items-center justify-center z-10">
              <img
                src={Apply1}
                alt="Apply1"
                className="w-[58px] h-[51px] rounded-[58px] object-cover"
              />
            </span>
            <span
              className="w-[58px] h-[51px] flex-shrink-0 rounded-[58px] flex items-center justify-center z-20"
              style={{ marginLeft: "-24px" }}
            >
              <img
                src={Apply2}
                alt="Apply2"
                className="w-[58px] h-[51px] rounded-[58px] object-cover"
              />
            </span>
            <span
              className="w-[58px] h-[51px] flex-shrink-0 rounded-[58px] flex items-center justify-center z-30"
              style={{ marginLeft: "-24px" }}
            >
              <img
                src={Apply3}
                alt="Apply3"
                className="w-[58px] h-[51px] rounded-[58px] object-cover"
              />
            </span>
          </div>
          <div className="font-montserrat">
            <span>Sign Up for the </span>
            <span className="font-bold hidden md:inline">BR[</span>
            <span className="text-t-blue-1 font-bold hidden md:inline">AI</span>
            <span className="font-bold hidden md:inline">]N</span>
            <span className="font-bold hidden md:inline"> GAIN </span>
            <span className="font-bold">Newsletter</span>
            {/* <span className="hidden lg:inline"> - Stay Ahead of the Curve</span> */}
          </div>
        </div>

        <form
          className="flex gap-[4px] w-full max-w-max items-center justify-center"
          onSubmit={handleSubscribe}
        >
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="text-[14px] py-[6px] px-[14px] w-[240px] h-[32px] bg-white font-roboto rounded-[4px] font-light"
          />
          <button className="rounded-[4px] bg-[#0060C7] flex w-[116px] h-[31px] px-[16px] py-[10px] font-roboto justify-center items-center gap-[4px] shrink-0 text-white text-[14px] cursor-pointer hover:bg-[#0050a7]">
            Subscribe
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewsLetter;
